<template>
  <div
    class="d-flex align-center justify-space-between px-5 py-4"
    style="height: 72px"
  >
    <div class="d-flex align-center">
      <v-avatar
        v-if="solicitanteNome"
        size="38"
        class="cursor-pointer"
        :class="`v-avatar-light-bg `"
      >
        <span>{{ solicitanteNome.toUpperCase().substr(0, 1) }}</span>
      </v-avatar>

      <v-avatar
        v-else
        size="38"
        class="cursor-pointer"
        :class="`v-avatar-light-bg `"
      />

      <div class="d-flex flex-column">
        <p class="mb-0 text--primary font-weight-medium mx-2">
          {{ solicitanteNome }}
        </p>

        <span class="text--disabled text-xs mx-2">{{ solicitanteEmail }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    solicitanteNome: {
      type: String,
      required: true,
    },
    solicitanteEmail: {
      type: String,
      default: null,
    },
  },
}
</script>
